
import React, { Component } from 'react';
import { Search, Grid, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default class SearchList extends Component {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    filterName: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    icon: PropTypes.string,
    results: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      image: PropTypes.string,
    })).isRequired,
    placeholder: PropTypes.string,
    noResultsMessage: PropTypes.string.isRequired,
    value: PropTypes.string,
  }
  static defaultProps = {
    hasSearch: false,
    headerText: 'Find Options',
    options: [],
    placeholder: 'Find Options...',
    value: '',
  }
  static getPropsToState = (props) => {
    const value = props.value || '';
    const showNoResults = props.showNoResults || true;
    return {
      value,
      showNoResults,
    };
  }
  constructor(props) {
    super(props);
    const state = SearchList.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = SearchList.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleClose = () => {
    this.setState({
      value: '',
    }, () => {
      this.props.onClose(this.props.filterName);
    });
  }
  handleResultSelect = (e, { result }) => {
    this.props.onSelect(result, this.props.filterName);
  }
  handleSearchChange = (e, { value }) => {
    const showNoResults = true;
    this.setState({
      value,
      showNoResults,
    }, () => {
      this.props.onChange(value);
    });
  }
  render() {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Grid>
              <Grid.Row>
                <Grid.Column textAlign="left" width={14}>
                  <Search
                    aligned="left"
                    className="searchlist"
                    fluid
                    icon={this.props.icon || 'caret down'}
                    loading={this.props.loading}
                    onResultSelect={this.handleResultSelect}
                    onSearchChange={this.handleSearchChange}
                    results={this.props.results}
                    value={this.state.value}
                    placeholder={this.props.placeholder}
                    noResultsMessage={this.props.noResultsMessage}
                    onFocus={() => {
                      const showNoResults = false;
                      this.setState({ showNoResults });
                    }}
                    showNoResults={this.state.showNoResults}
                  />
                </Grid.Column>
                {
                this.props.isActive &&
                  <Grid.Column width={2} verticalAlign="middle" className="clearicon">
                    <Button
                      as="a"
                      circular
                      icon="x"
                      onClick={this.handleClose}
                      size="mini"
                      title="Clear"
                    />
                  </Grid.Column>
                }
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filters/SearchList.jsx